import script from "./PaymentDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentDetails.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentDetails.vue?vue&type=style&index=0&id=97d52142&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97d52142"]])

export default __exports__